import { Injectable } from '@angular/core';
import { ApiService } from '../../http/api.service';
import { PageRequestModel, PageResponseModel } from '../../models/page.model';
import { LinkManualItemCriteriaModel, LinkManualItemModel } from '../../models/link-manual/link-manual.model';

@Injectable({
  providedIn: 'root',
})
export class LinkManualService {
  constructor(private apiService: ApiService) {}

  ///api/v1/admin/Admin-Manual-Elit/ChkAuthManualEli
  async authManual(): Promise<boolean> {
    const result = await this.apiService.post<boolean>(
      '/manual-elit/ChkAuthManualEli'
    );
    return result!;
  }

    
  async search(PageRequest: PageRequestModel<LinkManualItemCriteriaModel>): Promise<PageResponseModel<LinkManualItemModel>>{
    console.log(PageRequest);

     const dataResponse: PageResponseModel<LinkManualItemModel> = new PageResponseModel<LinkManualItemModel>();
    // const result = manualData
///api/v1/manual-eli/search
     const result = await this.apiService.post<PageResponseModel<LinkManualItemModel>>('/link-manual-eli/search',PageRequest);
     dataResponse.pageCount = result!.pageCount;
     dataResponse.pageNumber = result!.pageNumber;
     dataResponse.pageSize = result!.pageSize;
     dataResponse.totalItemCount = result!.totalItemCount;
     dataResponse.items = result!.items;
     return dataResponse;
 }


}
